import { render, staticRenderFns } from "./ListItemsLoadable.vue?vue&type=template&id=8468458c&"
import script from "./ListItemsLoadable.vue?vue&type=script&lang=js&"
export * from "./ListItemsLoadable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports